import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
const MENU_ITEM_CONTENTS_CSS = css `
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 5px;
`;
export const CreateGameMenuItemContents = ({ icon: SvgIconComponent, label }) => {
    return (_jsxs("div", { css: MENU_ITEM_CONTENTS_CSS, children: [SvgIconComponent && _jsx(SvgIconComponent, { fontSize: 'small' }), _jsx("span", { children: label })] }));
};
